import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Category(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.246 16.5a3.25 3.25 0 013.245 3.246 3.248 3.248 0 01-3.245 3.245A3.248 3.248 0 011 19.746 3.25 3.25 0 014.246 16.5zm7.723 0a3.25 3.25 0 013.245 3.246 3.248 3.248 0 01-3.245 3.245 3.248 3.248 0 01-3.243-3.245 3.248 3.248 0 013.243-3.245zm7.725 0a3.25 3.25 0 013.245 3.246 3.248 3.248 0 01-3.245 3.245 3.248 3.248 0 01-3.245-3.245 3.25 3.25 0 013.245-3.245zm-15.448 2a1.246 1.246 0 10.002 2.488 1.246 1.246 0 00-.002-2.487zm7.723 0a1.246 1.246 0 000 2.49 1.246 1.246 0 000-2.49zm7.725 0a1.246 1.246 0 10.002 2.488 1.246 1.246 0 00-.002-2.487zM4.278 8.728a3.248 3.248 0 013.244 3.245 3.248 3.248 0 01-3.244 3.245 3.25 3.25 0 01-3.245-3.245 3.25 3.25 0 013.245-3.245zm7.724 0a3.25 3.25 0 013.245 3.245 3.25 3.25 0 01-3.245 3.245 3.25 3.25 0 01-3.245-3.245 3.25 3.25 0 013.245-3.245zm7.723 0a3.25 3.25 0 013.245 3.245 3.25 3.25 0 01-3.245 3.245 3.25 3.25 0 01-3.245-3.245 3.25 3.25 0 013.245-3.245zm-15.447 2a1.246 1.246 0 000 2.49 1.246 1.246 0 000-2.49zm7.724 0a1.246 1.246 0 10.001 2.492 1.246 1.246 0 00-.001-2.492zm7.723 0a1.246 1.246 0 10.002 2.492 1.246 1.246 0 00-.002-2.492zM4.245 1A3.25 3.25 0 017.49 4.245 3.25 3.25 0 014.245 7.49 3.25 3.25 0 011 4.245 3.25 3.25 0 014.245 1zm7.724 0a3.248 3.248 0 013.245 3.245 3.248 3.248 0 01-3.245 3.245 3.25 3.25 0 01-3.244-3.245A3.25 3.25 0 0111.97 1zm7.724 0a3.25 3.25 0 013.245 3.245 3.25 3.25 0 01-3.245 3.245 3.25 3.25 0 01-3.245-3.245A3.25 3.25 0 0119.693 1zM4.245 3a1.246 1.246 0 10.001 2.492A1.246 1.246 0 004.245 3zm7.724 0a1.246 1.246 0 000 2.49 1.246 1.246 0 000-2.49zm7.724 0a1.246 1.246 0 10.002 2.492A1.246 1.246 0 0019.693 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoCategory = React.memo(Category);
export default MemoCategory;